import { IProfile } from "@/interfaces/IProfile";
import clsx from "clsx";
import Image, { StaticImageData } from "next/image";
import { useEffect, useState } from "react";
import { USER } from "@/constants/mock";

type AvatarBaseProps = Pick<IProfile, "avatar_img"> & { className?: string };

export default function AvatarBase(props: AvatarBaseProps) {
  const [avatar, setAvatar] = useState<string | StaticImageData>(
    props.avatar_img,
  );

  useEffect(() => {
    if (props.avatar_img) {
      setAvatar(props.avatar_img);
    }
  }, [props.avatar_img]);

  return (
    <div className={clsx("avatar", props.className)}>
      {props.avatar_img ? (
        <Image
          src={avatar}
          className="w-full h-full rounded-full overflow-hidden"
          alt="Profile"
          width="200"
          onError={() => setAvatar(USER.avatar_img)}
          height="200"
        />
      ) : (
        <div className="default-avatar w-full rounded-full h-full overflow-hidden">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="w-full h-full object-cover rounded-full scale-150"
          >
            <source src="/video/default-avatar.mp4" type="video/mp4" />
          </video>
        </div>
      )}
    </div>
  );
}
